// extracted by mini-css-extract-plugin
export default {"iconImage":"styles_iconImage__weF4X","icon":"styles_icon__EVdTl","detail":"styles_detail__BzDAd"};